<template>
  <div class="subnav">
    <NuxtLink v-for="item in items" :key="item.text" :to="{ name: item.name, params: { team: team.slug }, query: item.query }" :class="{ 'active': item.active }">
      {{ item.text }}
    </NuxtLink>
  </div>
</template>

<script setup>
const { t } = useI18n()
const route = useRoute()
const team = useTeamStore()

const items = computed(() => [
  {
    text: t('shared.nav.all'),
    name: route.name,
    active: !route.query?.side,
    query: {
      side: undefined
    }
  },
  {
    text: t('shared.nav.home'),
    name: route.name,
    active: route.query?.side === 'home',
    query: {
      side: 'home'
    }
  },
  {
    text: t('shared.nav.away'),
    name: route.name,
    active: route.query?.side === 'away',
    query: {
      side: 'away'
    }
  }
])
</script>
